const modules = import.meta.globEager('./modules/*.js')

export default modules
